var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-bg',[_c('div',{staticClass:"v-card"},[_c('div',{staticClass:"vc-title"},[_c('span',[_c('v-title-bg',[_vm._v("温度趋势")])],1)]),_c('div',{staticClass:"vc-chart"},[_c('mr-echarts',{attrs:{"options":_vm.options}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }